import React from 'react';

import { dggTheme } from '../../../../styles/dggTheme';
import { Content } from '../../molecules/Content/Content';
import * as styles from './SectionGroupHeader.styles';

export interface SectionGroupHeaderProps {
  heading: string;
  copy: string;
}

export const SectionGroupHeader = ({ heading, copy }: SectionGroupHeaderProps) => {
  return (
    <Content backgroundColor={dggTheme.colors.moodyBlue}>
      <div css={styles.root}>
        <h2 css={styles.heading}>{heading}</h2>
        <p css={styles.copy}>{copy}</p>
      </div>
    </Content>
  );
};
